import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import CadastroCliente from '@/views/CadastroCliente.vue'
import Clientes from '@/components/Clientes.vue'
import Municipios from '@/components/Municipios.vue'
import LoginView from '@/views/LoginView.vue'
import EditCliente from '@/components/EditCliente.vue'
import LicencaDetalhe from '@/components/LicencaDetalhe.vue'
import NotFound from '@/views/NotFound.vue'
import Uf from '@/components/Uf.vue'
import CadastroMunicipio from '@/views/CadastroMunicipio.vue'
import ConfiguracoesView from '@/views/ConfiguracoesView.vue'
import Licencas from '@/components/Licencas.vue'
import Planos from '@/components/Planos.vue'
import Produtos from '@/components/Produtos.vue'

const routes = [
  //Rota 404
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: NotFound
  },
  {
    path: '/',
    name: 'login',
    component: LoginView
  },
  {
    path: '/home',
    name: 'home',
    component: HomeView,
    meta: { requiresAuth: true },
  },
  {
    path: '/clientes',
    name: 'clientes',
    component: Clientes,
    meta: { requiresAuth: true },
  },
  {
    path: '/clientes/:codcliente',
    name: 'editar-cliente',
    component: EditCliente,
    meta: { requiresAuth: true },
  },
  {
    path: '/licencas',
    name: 'licencas',
    component: Licencas,
    meta: { requiresAuth: true },
  },
  {
    path: '/planos',
    name: 'planos',
    component: Planos,
    meta: { requiresAuth: true },
  },
  {
    path: '/produtos',
    name: 'produtos',
    component: Produtos,
    meta: { requiresAuth: true },
  },
  {
    path: '/clientes/cadastro',
    name: 'cadastro-cliente',
    component: CadastroCliente,
    meta: { requiresAuth: true },
  },
  {
    path: '/municipios',
    name: 'municipios',
    component: Municipios,
    meta: { requiresAuth: true },
  },
  {
    path: '/municipios/cadastro',
    name: 'cadastro-municipio',
    component: CadastroMunicipio,
    meta: { requiresAuth: true },
  },
  {
    path: '/ufs',
    name: 'ufs',
    component: Uf,
    meta: { requiresAuth: true },
  },
  {
    path: '/licenca/:hash',
    name: 'licenca-detalhe',
    component: LicencaDetalhe,
    meta: { requiresAuth: true },
  },
  {
    path: '/configuracoes',
    name: 'configuracoes',
    component: ConfiguracoesView,
    meta: { requiresAuth: true },
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Verifica a autenticação antes de cada navegação
router.beforeEach((to, _, next) => {
  const token = sessionStorage.getItem('token');
  
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!token) {
      next({ name: 'login' });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router
